import "./Welcome.css";
import { Button } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { setTextToSearch } from "../../../../store/cardTextSlice";
import { hide } from "../Home/homeVisibilitySlice";
import { useChatContext } from "../../../../Context/ChatContext";

const questions = [
  "How many student credit hour were taken in  English last semester?",
  "What share of English course enrollment are Math majors?",
  "What share of sections were taught by full-time faculty?",
  "What does contribution mean?",
  "List the top 5 programs in descending order based on contribution per SCH.",
 

];

export function Welcome() {
  const dispatch = useDispatch();
 const { setInputText, setTriggerSubmit } = useChatContext();
  const handleQuestionClick = (question: string) => {
    setInputText(question); 
    dispatch(hide());
    setTimeout(() => {
      setTriggerSubmit(true); // dispara el envío
    }, 1000);
  };

  return (
    <>
    <div className="welcome-message">
      <div className="title-content">
        <h1 className="bot-title">
          Hello, what questions do you have about your data?
        </h1>
      </div>
      <div className="subtitle-content">
        <p className="subtitle">
          I am your Economics AI Agent here to help you explore and analyze your
          institution's instructional economics. I will provide numerical and
          contextual answers. Soon, I will be able to help you with market
          research in PES Markets.
        </p>
      </div>

    </div>
      <div className="question-cards-container">
        {questions.map((q, index) => (
          <Button
            key={index}
            variant="outline-light"
            className="question-card w-100 mb-2 text-start"
            onClick={() => handleQuestionClick(q)}
          >
            <i className="bi bi-chat-left-text-fill me-2" /> {q}
          </Button>
        ))}
      </div>
    </>
  );
}
